export const InfrastructureIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#1D1C1C"
      stroke-width="1.35"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="4" y="4" width="16" height="6" rx="1.5"></rect>
      <rect x="4" y="14" width="16" height="6" rx="1.5"></rect>
      <line x1="8" y1="7" x2="8.01" y2="7"></line>
      <line x1="8" y1="17" x2="8.01" y2="17"></line>
    </svg>
  );
};
